import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import styled from 'styled-components';
import { Col, Row, Select, Button, Table } from 'antd';
import { ConsultaStore } from '../../stores/consultaStore';
import { inject, observer } from 'mobx-react';
import { Months } from '../../models';
import { AperturasTables } from './AperturasTables';
import { AperturaStore } from '../../stores';

const ConsultasWrapper = styled.div`
    margin: 0 auto;
    padding: 0 150px;
    max-width: 1600px;
`;

const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;

const ColStyled = styled(Col)`
    text-align: center;
`;

interface AperturasInnerProps extends RouteComponentProps {
    consultaStore?: ConsultaStore;
    aperturaStore?: AperturaStore;
}

@inject('consultaStore')
@inject('aperturaStore')
@observer
class AperturasInner extends React.Component<AperturasInnerProps, {}> {
    componentDidMount() {
        const { aperturaStore } = this.props;
        aperturaStore!.limpiarFiltrosConsulta();
    }
    renderEjercicio = () => {
        const fecha = new Date();
        return (
            <Select
                style={{ width: '100%' }}
                placeholder="Ejercicio"
                optionFilterProp="children"
                onChange={this.changeEjercicio}
                defaultValue="0"
            >
                <Select.Option key="0">Seleccione</Select.Option>
                <Select.Option key={fecha.getFullYear() + 1}>
                    {fecha.getFullYear() + 1}
                </Select.Option>
                <Select.Option key={fecha.getFullYear()}>{fecha.getFullYear()}</Select.Option>
            </Select>
        );
    };
    changeEjercicio = async (value: any) => {
        const { aperturaStore } = this.props;
        aperturaStore!.filtrosConsultaAperturas!.ejercicio = value;
        if (value != 0) {
            await aperturaStore!.getListaAperturas();
        }
    };

    renderMes = () => {
        return (
            <Select
                style={{ width: '100%' }}
                placeholder="Mes"
                optionFilterProp="children"
                onChange={this.handleMes}
                defaultValue="0"
            >
                <Select.Option key="0">Todos</Select.Option>
                {Months.map((mes, index) => (
                    <Select.Option key={index + 1}>{mes}</Select.Option>
                ))}
            </Select>
        );
    };

    handleMes = async (value: any) => {
        const { aperturaStore } = this.props;
        aperturaStore!.filtrosConsultaAperturas!.mes = value;
        await aperturaStore!.getListaAperturas();
    };

    render() {
        const { aperturaStore } = this.props;
        return (
            <>
                <ConsultasWrapper>
                    <Row style={{ textAlign: 'center' }}>
                        <PageHeader>Aperturas</PageHeader>
                    </Row>
                    <Row>
                        <ColStyled span={6}>
                            <strong>Ejercicio</strong> {this.renderEjercicio()}
                        </ColStyled>
                        <ColStyled span={6}>
                            <strong>Mes</strong>
                            {this.renderMes()}
                        </ColStyled>
                        <ColStyled span={6} />
                    </Row>
                    <Row style={{ padding: '20px' }}>
                        {aperturaStore!.filtrosConsultaAperturas!.ejercicio != 0 ? (
                            <AperturasTables />
                        ) : null}
                    </Row>
                </ConsultasWrapper>
            </>
        );
    }
}
export const Aperturas = withRouter(AperturasInner);
